import { render } from "./ProjectTable.vue?vue&type=template&id=b853deaa&scoped=true&ts=true"
import script from "./ProjectTable.vue?vue&type=script&lang=ts"
export * from "./ProjectTable.vue?vue&type=script&lang=ts"

import "./ProjectTable.vue?vue&type=style&index=0&id=b853deaa&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b853deaa"]])

export default __exports__